<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}" :bodyStyle="{paddingTop:'0px'}">
    <a-row slot="title">
      <a-col :span="24">
        <span>专题模板</span>
        <span class="tips">{{ subjectTemplateDto.title }}</span>
      </a-col>
    </a-row>
    <a-row :gutter="20">
      <div class="link-class" v-if="specialLinkUrl">专题链接：{{ specialLinkUrl }}</div>
      <a-col :xxl="8" :xl="8" :lg="8" :sm="7" :md="10">
        <div class="projectone">
          <img v-if="colorStyle == 1" :src="subjectTemplateDto.exampleImg"/>
          <img v-else :src="subjectTemplateDto.exampleImgTwo"/>
        </div>
      </a-col>
      <a-col :xxl="16" :xl="16" :lg="16" :sm="14" :md="14">
        <div class="thmemMain">
          <div class="themeNavInput">
            <span>色彩风格：</span>
            <a-radio-group v-model="colorStyle">
              <a-radio :value="1">青蓝色</a-radio>
              <a-radio :value="2">橙黄色</a-radio>
            </a-radio-group>
          </div>
          <div class="themeNavInput mtop20">
            <span>专题名称：</span>
            <a-input v-model="subjectCustTitle" :maxLength="8" placeholder="不超过8个字"/>
          </div>
          <div class="themeNavInput mtop20">
            <span>推广语：</span>
            <a-input v-model="subjectCustPromotion" :maxLength="20" placeholder="不超过20个字"/>
          </div>
          <div class="mtop20">
            <span>页面设置</span>
            <a-divider/>
          </div>
          <div class="dto-list" v-for="(item, index) in moduleDtoList" :key="index">
            <div class="mtop20">
              <span>模块{{ item.moduleType }}：{{ item.moduleIndexName }}</span>
            </div>
            <div class="mtop20 flex">
              <div v-if="item.moduleType == 1">
                <span>图片：</span>
                <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadFileUrl"
                  @change="file=> handleChange(file,index)"
                  :fileList="item.moduleBanner"
                >
                  <a-button type="primary" style="margin: 0 15px"> 点击上传</a-button>
                  <span>素材尺寸:750px*600px</span>
                </a-upload>
              </div>
              <div v-if="item.moduleType == 2">
                <span>标题：</span>
                <a-upload
                  name="file"
                  :multiple="false"
                  :action="uploadFileUrl"
                  @change="file=> handleChange(file,index)"
                  :fileList="item.moduleBanner"
                >
                  <a-button type="primary" style="margin: 0 15px"> 点击上传</a-button>
                  <span>素材尺寸:670px*44px</span>
                </a-upload>
                <div class="flex-items-center mtop20 ">
                  <div class="title">副标题：</div>
                  <a-input
                    v-model="item.moduleCustName"
                    style="width: 200px"
                    :maxLength="12"
                    :placeholder="item.moduleIndexName"/>
                  <div class="el-upload__tip" style="width:120px">不超过12个字</div>
                </div>
                <div class="mtop20">
                  <div class="title" style="display: inline-block">轮播图：</div>
                  <custom-upload-pro-images style="display: inline-block"
                                            v-model="item.imgs"
                                            :isProduct="false"
                                            :isTransition="true"
                                            :tips="'最多上传5张，尺寸670*400'"
                                            :multiple-selected="true"
                                            :draggableUpdate="true">
                  </custom-upload-pro-images>
                </div>

                <div v-if="item.moduleType == 2" class="mtop20">
                  <div class="mtop20 flex-items-center">
                    <div class="title">商品：</div>
                    <a-button @click="getProductList(index)" style="margin-left: 20px">关联</a-button>&nbsp;&nbsp;
                    <div class="el-upload__tip">下方已选择商品拖动可排序</div>
                  </div>
                </div>
                <div class="mtop20" v-if="item.moduleType == 2">
                  <custom-dragging-table
                    :columns="getTableColumns()"
                    @draggable="(value) => onDraggableChange(index, value)"
                    :data-list="item.moduleDetailDtoList ? item.moduleDetailDtoList : []"
                  >
                  <span slot="sortIdSlots" slot-scope="rowItem">
                    {{ rowItem.index + 1 }}
                  </span>
                    <div class="name-title" slot="moduleProName" slot-scope="rowItem">
                      <a-tooltip placement="topLeft">
                        <div slot="title">
                          <span>{{ rowItem.record.optionName }}</span>
                        </div>
                        {{ rowItem.record.optionName }}
                      </a-tooltip>
                    </div>
                    <span slot="action" slot-scope="rowItem">
                    <a-button type="link" @click="deleteList(rowItem.record, index)">移除</a-button>
                  </span>
                  </custom-dragging-table>
                </div>

              </div>
              <div v-if="item.moduleType == 3">
                <div class="mtop20">
                  <span>标题：</span>
                  <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadFileUrl"
                    @change="file=> handleChange(file,index)"
                    :fileList="item.moduleBanner"
                  >
                    <a-button type="primary" style="margin: 0 15px"> 点击上传</a-button>
                    <span>素材尺寸:670px*44px</span>
                  </a-upload>
                </div>
                <div class="mtop20" style="display: flex">
                  <span>酒店介绍1：</span>
                  <a-textarea
                    v-model="item.moduleCustName"
                    placeholder="请输入"
                    :rows="4"
                    :maxLength="150"
                    style="width: 100%"/>
                </div>
                <div class="mtop20">
                  <span>通栏图片：</span>
                  <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadFileUrl"
                    @change="file=> handleChange(file,index,'threeImg')"
                    :fileList="item.moduleBannerTwo"
                  >
                    <a-button type="primary" style="margin: 0 15px"> 点击上传</a-button>
                    <span>素材尺寸:750px*448px</span>
                  </a-upload>
                </div>
                <div class="mtop20" style="display: flex">
                  <span>酒店介绍2：</span>
                  <a-textarea
                    v-model="item.moduleTwoName"
                    placeholder="请输入"
                    :rows="4"
                    :maxLength="240"
                    style="width: 100%"/>
                </div>

                <div class="mtop20">
                  <div class="title" style="display: inline-block">酒店图组：</div>
                  <custom-upload-pro-images style="display: inline-block"
                                            v-model="item.imgs"
                                            :isProduct="false"
                                            :isTransition="true"
                                            :maxCount="9"
                                            :tips="'数量上传2-9张，尺寸330*220'"
                                            :multiple-selected="true"
                                            :draggableUpdate="true">
                  </custom-upload-pro-images>
                </div>
              </div>
              <div v-if="item.moduleType == 4">
                <div class="mtop20">
                  <span>标题：</span>
                  <a-upload
                    name="file"
                    :multiple="false"
                    :action="uploadFileUrl"
                    @change="file=> handleChange(file,index)"
                    :fileList="item.moduleBanner"
                  >
                    <a-button type="primary" style="margin: 0 15px"> 点击上传</a-button>
                    <span>素材尺寸:670px*44px</span>
                  </a-upload>
                </div>
                <div class="flex-items-center mtop20 ">
                  <div class="title">副标题：</div>
                  <a-input v-model="item.moduleCustName"
                           style="width: 200px"
                           :maxLength="12" :placeholder="item.moduleIndexName"/>
                  <div class="el-upload__tip" style="width:120px">不超过12个字</div>
                </div>

                <div class="flex-items-center mtop20" style="display: flex;align-items: flex-start">
                  <div class="title">周边服务：</div>
                  <div>
                    <div style="display: flex" v-for="(i,idx) in item.moduleDetailDtoList" :key="idx">
                      <a-upload
                        name="file"
                        style="width: 160px"
                        list-type="picture-card"
                        :multiple="false"
                        :action="uploadFileUrl"
                        @change="file=> handleChange(file,index,'fourImg',idx)"
                        :fileList="i.img"
                      >
                        <div v-if="!i.img.length">
                          <a-icon :type="'plus'"/>
                          <div class="ant-upload-text">
                            上传
                            <span style="display: block;text-align: center">256px*176px</span>
                          </div>
                        </div>

                      </a-upload>
                      <div>
                        <a-input v-model="i.title"
                                 style="width: 100%;margin-top: 10px"
                                 :maxLength="12" placeholder="请输入标题，字数3~12个字"/>
                        <a-input v-model="i.dec"
                                 style="width: 100%;margin-top: 10px"
                                 :maxLength="32" placeholder="请输入描述，字数10~32个字"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="item.moduleType == 5">
                <div class="flex-items-center mtop20 ">
                  <div class="title">版权说明：</div>
                  <a-input v-model="item.moduleCustName"
                           style="width: 200px"
                           :maxLength="12" :placeholder="item.moduleIndexName"/>
                  <div class="el-upload__tip" style="width:120px">不超过12个字</div>
                </div>
              </div>

              <!-- <div class="flex-items-center">
                 <div class="title">类型：文字</div>
                   <a-input v-model="item.moduleCustName"
                     style="margin-left:20px;width: 200px"
                     :maxLength="8" :placeholder="item.moduleIndexName"/>
                 <div class="el-upload__tip" style="width:120px">不超过8个字</div>
               </div>-->
              <!-- <div v-if="item.moduleType == 3" class="mtop20">
                 <div><span>模块{{ item.moduleIndex }}：{{ item.moduleIndexName }}商品 </span></div>
                 <div class="mtop20 flex-items-center">
                   <div class="title">类型：商品</div>
                   <a-button @click="getProductList(index)" style="margin-left: 20px">关联</a-button>&nbsp;&nbsp;
                   <div class="el-upload__tip">下方已选择商品拖动可排序</div>
                 </div>
               </div>
               <div class="mtop20" v-if="item.moduleType == 3">
                 <custom-dragging-table
                   :columns="getTableColumns()"
                   @draggable="(value) => onDraggableChange(index, value)"
                   :data-list="item.moduleDetailDtoList ? item.moduleDetailDtoList : []"
                 >
                   <span slot="sortIdSlots" slot-scope="rowItem">
                     {{rowItem.index + 1}}
                   </span>
                   <span slot="typeSlots" slot-scope="rowItem">
                     {{ rowItem.record.moduleCatalogId | productTypeName }}
                   </span>
                   <div class="name-title" slot="moduleProName" slot-scope="rowItem">
                     <a-tooltip placement="topLeft">
                       <div slot="title">
                         <span>{{ rowItem.record.moduleProName }}</span>
                       </div>
                       {{ rowItem.record.moduleProName }}
                     </a-tooltip>
                   </div>
                   <span slot="action" slot-scope="rowItem">
                     <a-button type="link" @click="deleteList(rowItem.record, index)">移除</a-button>
                   </span>
                 </custom-dragging-table>
               </div>-->
            </div>
            <!-- <div class="couponMain" v-if="item.moduleType == 5">
               <span>类型：优惠券</span>
               <a-button @click="openCouponList" style="margin-left: 20px">关联</a-button>
             </div>
             <div class="mtop20" v-if="item.moduleType == 5">
               <a-table
                 :dataSource="chooseCouponList"
                 :columns="getChooseCoupon()"
                 :pagination="false"
                 rowKey="couponId"
                 columnWidth="700px"
               >
                 <span slot="typeSlots" slot-scope="text, record">
                   {{ record.moduleCatalogId | ProductTypeName }}
                 </span>
                 <span slot="action" slot-scope="text, record">
                   <a-button type="link" @click="deleteCouponList(record)">移除</a-button>
                 </span>
               </a-table>
             </div>-->
          </div>
          <div class="mtop20">
            <a-button type="primary" @click="submitData(false)" :loading="submitLoading1">保存并生成</a-button>
            <a-button @click="submitData(true)" style="margin-left:15px" :loading="submitLoading2">预览</a-button>
          </div>
        </div>
      </a-col>
    </a-row>

    <!--关联商品-->
    <selected-product-dialog
      title="选择商品"
      :show="showSelectedDialog"
      :itemNames="['search_proId', 'search_proName']"
      :query-params="selectedQueryParams"
      params-path="user/home/getSelectProductAllList"
      base-key="userUrl"
      row-key="proId"
      :width="1000"
      ref="pageList"
      :page-size="10"
      @close="showSelectedDialog = false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="selectedFormLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="selectedFormLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <div slot="proName" slot-scope="rowItem" class="ellipsis-text">
        <a-tooltip placement="topLeft">
          <div slot="title">
            <span>{{ rowItem.text }}</span>
          </div>
          {{ rowItem.text }}
        </a-tooltip>
      </div>
      <div slot="action" slot-scope="rowItem">
        <a @click="confirmHouseSTyle(rowItem.record)">选择</a>
      </div>
    </selected-product-dialog>


    <!--关联房型-->
    <selected-product-dialog
      title="选择房型"
      :show="houseSTyleDialog"
      :query-params="houseSTyleParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
      row-key="optionId"
      :width="1000"
      ref="houseSTyleList"
      :page-size="10"
      @close="houseSTyleDialog = false"
      :columns="getHouseColumns()"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <div slot="proName" slot-scope="rowItem" class="ellipsis-text">
        <a-tooltip placement="topLeft">
          <div slot="title">
            <span>{{ rowItem.record.optionName }}</span>
          </div>
          {{ rowItem.record.optionName }}
        </a-tooltip>
      </div>
      <div slot="footer">
        <div class="dialogBtn">
          <a-button @click="houseSTyleDialog = false" style="margin-right: 15px">取消</a-button>
          <a-button type="primary" @click="confirmProduct">确定</a-button>
        </div>
      </div>
    </selected-product-dialog>

    <!--关联优惠券-->
    <selected-product-dialog
      title="选择优惠券"
      :show="showCouponDialog"
      :itemNames="['search_couponName']"
      :requestPromise="loadCouponPromise"
      :queryParams="selectedParams"
      :width="900"
      ref="pageList"
      :page-size="5"
      @close="showCouponDialog = false"
      :columns="getCouponColumns()"
    >
      <a-form-item label="名称" slot="search_couponName" v-bind="selectedFormLayout">
        <a-input v-model="selectedParams.couponName" style="width: 170px" placeholder="请输入优惠券名称"></a-input>
      </a-form-item>
      <div slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="couponChoose(rowItem)">选择</a-button>
      </div>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import CustomPageList from '../../../../customComponents/CustomPageList'
import searchForm from '../../../../utils/mixins/searchFormMixins'
import formMixin from '../../../../utils/mixins/formMixins'
import CustomizedMixins from './CustomizedMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import EditableCell from '../../../platform/component/editableCell'
import CustomDraggingTable from '@/customComponents/CustomDraggingTable/CustomDraggingTable'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'

export default {
  name: 'ServiceThemeTemplate',
  mixins: [searchForm, formMixin, CustomizedMixins],
  components: { CustomPageList, SelectedProductDialog, EditableCell, CustomDraggingTable, CustomUploadProImages },
  data() {
    return {
      subjectTemplateDto: {}, // '模板的相关数据'
      subjectId: this.$route.query.subjectId, // '专题 id'
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      subjectMerchantId: this.$route.query.subjectMerchantId, // '专题 对应的 id'
      h5DomainUrl: this.$route.query.domainUrl,
      moduleDtoList: [], // '获取 专题的配置信息拼接页面'
      subjectCustTitle: '',
      submitLoading1: false,
      submitLoading2: false,
      queryParams: {},
      uploadFileUrl: this.getAppConfig().baseUrl + '/base/upload', //文件上传地址
      listData: [], // '投放设置数据'
      showSelectedDialog: false,
      selectedQueryParams: {
        proName: '',
        proId: '',
        shelfStatus: '1',
        categoryId: 2
      },
      selectedFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      selectedRowKeys: [],
      proIdList: [],
      indexKey: 0,
      textareaText: '',
      showCouponDialog: false,
      selectedParams: {
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponName: '', // 优惠券名称
        specialId: this.$route.query.subjectId,
        couponPlatformId: this.getPlatformConfig().platformId
      },
      chooseCouponList: [],
      loadCouponPromise: params => this.getCouponListPromise(params),
      specialLinkUrl: '',
      subjectCustPromotion: '',
      colorStyle: 1,
      houseSTyleDialog: false,
      houseSTyleParams: {},//房型参数
      templateId: this.$route.query.templateId ? this.$route.query.templateId : '', // '专题模板 id'
      customSubjectMerchantId: this.$route.query.customSubjectMerchantId ? this.$route.query.customSubjectMerchantId : '',//定制专题Id
      loadPromise: params => this.getListPromise(params),
      goodsChoose: 0
    }
  },
  created() {
  },
  mounted() {
    this.getMerchantSubjectTemplate()
    this.getTemplateDetail()
    //this.getSelectOptionList()
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getProService().post('/product/option/available/optionList', params)
    },
    getSelectOptionList() { //获取酒店房型集合
      let params = {
        optionIdList: ['5694937', '5694938'],
        proId: 806263
      }
      this.getHttpServices().getApiService().post('/api/details/select/optionList', params).then(res => {

      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCouponListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
    },
    getTemplateDetail() { //获取定制专题模板详情
      this.getHttpServices().getServerApiService().post('/customSubject/market/getTemplateDetail', { templateId: this.templateId })
        .then(res => {
          this.subjectTemplateDto = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    async getMerchantSubjectTemplate() {
      let res = {
        customSubjectMerchantId: this.customSubjectMerchantId,
        templateId: this.templateId,
        colorStyle: 1, //色彩风格 1.青蓝色 2.橙黄色
        name: '',// 专题名称
        spreadWord: '',//推广语
        moduleDtoList: [
          {
            moduleBanner: [],
            moduleIndexName: '顶部图片',
            moduleTitle: '顶部图片',
            moduleType: 1
          },
          {
            moduleCustName: null, //副标题
            moduleBanner: [],
            imgs: [],
            moduleDetailDtoList: [],//产品IDs
            goodsChoose: 0,
            moduleIndexName: '人气爆款，品质房型',
            moduleTitle: '人气爆款，品质房型',
            moduleType: 2
          },
          {
            moduleCustName: null,
            moduleBanner: [],
            moduleBannerTwo: [],
            moduleTwoName: '',
            imgs: [],
            moduleIndexName: '酒店介绍',
            moduleTitle: '酒店介绍',
            moduleType: 3
          },
          {
            moduleCustName: null,
            moduleBanner: [],
            moduleDetailDtoList: [
              {
                img: [],
                title: '',
                dec: ''
              },
              {
                img: [],
                title: '',
                dec: ''
              },
              {
                img: [],
                title: '',
                dec: ''
              }
            ],
            moduleIndexName: '特色服务，酒店周边',
            moduleTitle: '特色服务，酒店周边',
            moduleType: 4
          },
          {
            moduleCustName: null,
            moduleBanner: [],
            moduleIndexName: '版权说明',
            moduleTitle: '版权说明',
            moduleType: 5
          }

        ]
      }
      if (this.customSubjectMerchantId) {
        res = await this.getSubjectDetailPromise()
        this.goodsChoose = res.moduleDtoList[1].goodsChoose
      }
      this.colorStyle = res.colorStyle
      this.customSubjectMerchantId = this.$route.query.customSubjectMerchantId ? res.customSubjectMerchantId : ''
      this.templateId = this.customSubjectMerchantId ? res.templateId : this.$route.query.templateId
      this.subjectCustPromotion = res.spreadWord
      this.subjectCustTitle = res.name
      let moduleDtoList = JSON.parse(JSON.stringify(res.moduleDtoList))
      moduleDtoList.forEach((item, index) => {
        if (item.moduleBanner && item.moduleBanner.length) {
          item.moduleBanner = [{ uid: '-1', name: item.moduleBanner[0], status: 'done', url: item.moduleBanner[0] }]
        }
        if (item.moduleType == 3) {
          if (item.moduleBannerTwo && item.moduleBannerTwo.length) {
            item.moduleBannerTwo = [{
              uid: '-1',
              name: item.moduleBannerTwo[0],
              status: 'done',
              url: item.moduleBannerTwo[0]
            }]
          }
        }
        if (item.moduleType == 4) {
          if (item.moduleDetailDtoList && item.moduleDetailDtoList.length) {
            item.moduleDetailDtoList.forEach((i, index) => {
              if (i.img && i.img.length) {
                i.img = [{ uid: '-1', name: i.img[0], status: 'done', url: i.img[0] }]
              }
            })
          }
        }
      })
      console.error('moduleDtoList', moduleDtoList)
      this.moduleDtoList = moduleDtoList
    },
    getSubjectDetailPromise() {
      return new Promise((resolve) => {
        let params = {
          customSubjectMerchantId: this.customSubjectMerchantId,
          platformId: this.platformId,
          merchantId: this.merchantId
        }
        this.getHttpServices().getServerApiService().post('/customSubject/market/getSubjectDetail', params)
          .then(res => {
            res.moduleDtoList = JSON.parse(res.moduleDtoList)
            resolve(res)
          }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    handleBefore(file) {
      if (this.handleBeforeUploadDocxFile(file.file)) {
        return true
      }
      return false
    },
    handleChange(file, index, name, idx) {
      //  图片上传成功
      this.getLogUtils().logWithTag('图片下标', file)
      if (file.file.status != 'removed') {
        if (!this.handleBefore(file)) {
          return
        }
        const url = this.getLatestUrlFromFileList(file.fileList)
        this.getLogUtils().logWithTag('上传图片URL', url)
        if (name == 'threeImg') {
          this.moduleDtoList[index].moduleBannerTwo = [...file.fileList]
          this.moduleDtoList[index].moduleBannerTwo = this.moduleDtoList[index].moduleBannerTwo.slice(-1)
        }
        if (name == 'fourImg') {
          this.moduleDtoList[index].moduleDetailDtoList[idx].img = [...file.fileList]
          this.moduleDtoList[index].moduleDetailDtoList[idx].img = this.moduleDtoList[index].moduleDetailDtoList[idx].img.slice(-1)
        } else {
          if (name != 'threeImg' && name != 'fourImg') {
            this.moduleDtoList[index].moduleBanner = [...file.fileList]
            this.moduleDtoList[index].moduleBanner = this.moduleDtoList[index].moduleBanner.slice(-1)
          }
        }
      } else {
        if (name == 'threeImg') {
          this.moduleDtoList[index].moduleBannerTwo = []
        }
        if (name == 'fourImg') {
          this.moduleDtoList[index].moduleDetailDtoList[idx].img = []
        } else {
          this.moduleDtoList[index].moduleBanner = []
        }
      }
      this.getLogUtils().logWithTag('moduleDtoList', this.moduleDtoList)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      let keys = []
      let rows = []
      if (selectedRowKeys.length < 4) {
        selectedRows.forEach(v => {
          keys.push(v.optionId)
          rows.push(v)
        })
      } else {
        return this.$message.error('房型选择不能超过3个')
      }
      console.error('keys', keys)
      this.selectedRowKeys = keys
      this.proIdList = rows
    },
    getProductList(index) {
      this.showSelectedDialog = true
      this.indexKey = index
    },
    confirmHouseSTyle(record) { //选择房型
      this.houseSTyleDialog = true
      this.showSelectedDialog = false
      this.selectedRowKeys = []
      this.proIdList = []
      let that = this
      this.houseSTyleParams = {
        proId: record.proId
      }
      this.$nextTick(() => {
        setTimeout(() => {
          that.$refs.houseSTyleList.refresh(true)
          that.$refs.houseSTyleList.updateSelect([], [])
        }, 300)
      })
    },
    confirmProduct() {
      if (this.proIdList.length < 1) {
        this.$message.error('请选择要操作的商品')
        return
      }
      this.showSelectedDialog = false
      this.houseSTyleDialog = false
      let indextype = this.indexKey
      this.goodsChoose = this.houseSTyleParams.proId
      this.moduleDtoList[indextype].moduleDetailDtoList = this.proIdList
      this.getLogUtils().logWithTag('moduleDetailDtoList', this.moduleDtoList[indextype].moduleDetailDtoList)
    },
    onDraggableChange(index, sortList) {
      this.moduleDtoList[index].moduleDetailDtoList = sortList
      this.getLogUtils().logWithTag('index', index)
      this.getLogUtils().logWithTag('sortList', sortList)
    },
    deleteList(record, index) {
      let arr = this.moduleDtoList[index].moduleDetailDtoList
      arr.forEach((item, index) => {
        if (item.optionId === record.optionId) {
          arr.splice(index, 1)
        }
      })
      this.moduleDtoList[index].moduleDetailDtoList = arr
    },
    // '保存商户的专题'
    submitData(flag) {
      if (!this.subjectCustTitle) {
        this.$message.error('专题名称不能为空')
        return
      }
      console.error('this.moduleDtoList', this.moduleDtoList)
      for (const k in this.moduleDtoList) {
        if (!this.moduleDtoList[k].moduleBanner.length && this.moduleDtoList[k].moduleType < 5) {
          return this.$message.error('模块' + (Number(k) + 1) + '标题图片必传')
        }
        if (this.moduleDtoList[k].moduleType == 2) {
          console.error('this.moduleDtoList[k].moduleCustName', this.moduleDtoList[k].moduleCustName)
          if (!this.moduleDtoList[k].moduleCustName) {
            return this.$message.error('品质酒店模块，副标题未填写')
          }
          if (!this.moduleDtoList[k].imgs.length) {
            return this.$message.error('品质酒店模块，轮播图未上传')
          }
        }
        if (this.moduleDtoList[k].moduleType == 3) {
          if (!this.moduleDtoList[k].moduleCustName) {
            return this.$message.error('请输入酒店介绍')
          }
          if (!this.moduleDtoList[k].moduleTwoName) {
            return this.$message.error('请输入酒店介绍2')
          }
          if (!this.moduleDtoList[k].moduleBannerTwo.length) {
            return this.$message.error('请上传酒店介绍的通栏图片')
          }
          if (this.moduleDtoList[k].imgs.length < 2) {
            return this.$message.error('酒店图组相片未上传或已上传数量不足，请检查')
          }
        }
        if (this.moduleDtoList[k].moduleType == 4) {
          if (!this.moduleDtoList[k].moduleCustName) {
            return this.$message.error('特色服务，酒店周边模块副标题未填写')
          }
          if (!this.moduleDtoList[k].moduleDetailDtoList[0].img.length || !this.moduleDtoList[k].moduleDetailDtoList[0].title || !this.moduleDtoList[k].moduleDetailDtoList[0].dec || !this.moduleDtoList[k].moduleDetailDtoList[1].img.length || !this.moduleDtoList[k].moduleDetailDtoList[1].title || !this.moduleDtoList[k].moduleDetailDtoList[1].dec || !this.moduleDtoList[k].moduleDetailDtoList[2].img.length || !this.moduleDtoList[k].moduleDetailDtoList[2].title || !this.moduleDtoList[k].moduleDetailDtoList[2].dec) {
            return this.$message.error('特色服务，周边服务三组图片、标题、描述都为必填项')
          }
          if (this.moduleDtoList[k].moduleDetailDtoList[0].title.length < 3 || this.moduleDtoList[k].moduleDetailDtoList[1].title.length < 3 || this.moduleDtoList[k].moduleDetailDtoList[2].title.length < 3) {
            return this.$message.error('特色服务，周边服务的标题最小输入3个字')
          }
          if (this.moduleDtoList[k].moduleDetailDtoList[0].dec.length < 10 || this.moduleDtoList[k].moduleDetailDtoList[1].dec.length < 10 || this.moduleDtoList[k].moduleDetailDtoList[2].dec.length < 10) {
            return this.$message.error('特色服务，周边服务的描述最小输入10个字')
          }
        }
      }
      let data = {}
      data.merchantId = this.merchantId
      data.platformId = this.platformId
      data.customSubjectMerchantId = this.customSubjectMerchantId
      data.templateId = this.templateId
      data.colorStyle = this.colorStyle
      data.name = this.subjectCustTitle
      data.spreadWord = this.subjectCustPromotion
      let list = JSON.parse(JSON.stringify(this.moduleDtoList))
      list.forEach((item, index) => {
        item.moduleBanner = this.getUrlFromFileListArr(item.moduleBanner)
        if (item.moduleType == 2) {
          item.goodsChoose = this.goodsChoose
        }
        if (item.moduleType == 3) {
          item.moduleBannerTwo = this.getUrlFromFileListArr(item.moduleBannerTwo)
        }
        if (item.moduleType == 4) {
          if (item.moduleDetailDtoList && item.moduleDetailDtoList.length) {
            item.moduleDetailDtoList.forEach((i, index) => {
              i.img = this.getUrlFromFileListArr(i.img)
            })
          }
        }
      })
      console.error('list', list)
      data.moduleDtoList = JSON.stringify(list)
      this.submitLoading1 = true
      this.submitLoading2 = true
      this.getHttpServices().getServerApiService().post('/customSubject/market/saveSubject', data).then(res => {
        this.$message.success('专题制作成功')
        this.clearH5Cache()
        if (!flag) {
          this.goStyleService()
        } else {
          this.customSubjectMerchantId = res
          this.goH5SpecialUrl(res)
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => {
        this.submitLoading1 = false
        this.submitLoading2 = false
      })
    },
    goStyleService() {
      this.$router.push({
        name: 'CustomizedList',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    openCouponList() {
      this.showCouponDialog = true
    },
    couponChoose(rowItem) {
      if (this.chooseCouponList.length < 10) {
        if (this.chooseCouponList.length > 0) {
          let flag = false
          this.chooseCouponList.map(item => {
            if (item.couponId == rowItem.record.couponId) {
              this.$message.error('请勿重复添加优惠券')
              flag = true
            }
          })
          if (!flag) {
            this.chooseCouponList.push(rowItem.record)
            this.showCouponDialog = false
          }
        } else {
          this.chooseCouponList.push(rowItem.record)
          this.showCouponDialog = false
        }
      } else {
        this.$message.error('最多添加10个优惠券')
      }
    },
    deleteCouponList(record) {
      if (this.chooseCouponList.length > 0) {
        const tags = this.chooseCouponList.filter(tag => tag.couponId !== record.couponId)
        this.chooseCouponList = tags
      }
    },
    //是否展示标题
    showModuleIndexName(data) {
      if (data.moduleType == 3) {
        if (data.canWriteModuleTitle) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    //预览H5商城路径url
    goH5SpecialUrl(customSubjectMerchantId) {
      if (customSubjectMerchantId) {
        let url = '/other/RailSpecial?p=1_' + this.merchantId + '_' + this.merchantId + '&customSubjectMerchantId=' + customSubjectMerchantId
        let url_page = this.$store.getters.h5DomainUrl + url
        window.open(url_page)
      } else {
        this.$message.error('预览错误，请联系管理员')
      }
    },
    //表格头部
    getTableColumns() {
      return [
        {
          title: '排序',
          dataIndex: 'iconSort',
          scopedSlots: { customRender: 'sortIdSlots' },
          width: '50px'
        },
        {
          title: '房型/计划ID',
          dataIndex: 'optionId',
          width: '100px'
        },
        {
          title: '房型/价格计划名称',
          dataIndex: 'moduleProName',
          scopedSlots: { customRender: 'moduleProName' },
          width: '40%'
        },
        {
          title: '价格',
          dataIndex: 'minSalePrice'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '80px',
          fixed: 'right'
        }
      ]
    },
    //选择产品弹窗header
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          scopedSlots: { customRender: 'proName' },
          width: '300px'
        },
        {
          title: '商品分类',
          dataIndex: 'proCatalogName',
          width: '100px'
        },
        {
          title: '省份',
          dataIndex: 'proProvinceName'
        },
        {
          title: '城市',
          dataIndex: 'proCityName'
        },
        /* {
           title: '状态',
           dataIndex: 'modularTitle'
         },*/
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '120px',
          fixed: 'right'
        }
      ]
    },
    //房型
    getHouseColumns() {
      return [
        {
          title: '房型ID',
          dataIndex: 'optionId'
        },
        {
          title: '房型/价格计划名称',
          dataIndex: 'proName',
          scopedSlots: { customRender: 'proName' },
          width: '400px'
        },
        {
          title: '价格',
          dataIndex: 'minSalePrice'
        }
      ]
    },
    //优惠券
    getCouponColumns() {
      return [
        {
          title: '优惠券Id',
          dataIndex: 'couponId',
          width: '100px'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          width: '250px'
        },
        {
          title: '优惠券金额',
          dataIndex: 'couponAmout',
          width: '140px'
        },
        {
          title: '使用类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px',
          fixed: 'right'
        }
      ]
    },
    getChooseCoupon() {
      return [
        {
          title: '优惠券Id',
          dataIndex: 'couponId',
          width: '100px'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          width: '250px'
        },
        {
          title: '优惠券金额(元)',
          dataIndex: 'couponAmout',
          width: '140px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px',
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
@import '../../../CustomPage';

.projectLeft {
  span {
    display: block;
    font-size: 16px;
    margin-top: 15px;
  }

  img {
    width: 200px;
    height: 200px;
    display: block;
    margin-top: 15px;
  }

  p {
    color: #777;
  }
}

.projectone {
  height: 667px;
  overflow-y: scroll;

  img {
    max-width: 375px;
    width: 100%;
  }
}

.dialogBtn {
  display: flex;
  justify-content: flex-end;
}

.couponMain {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
}

.themeNavInput {
  span {
    display: inline-block;
    width: 80px;
    text-align: right;
  }
}

.ml40 {
  margin-left: 40px;
}

.mtop20 {
  margin-top: 20px;
}

.flex-items-center {
  display: flex;
  align-items: center;
}

.name-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  width: 100%;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 300px
}

.tips {
  font-size: 14px;
  padding-left: 15px;
}

.link-class {
  line-height: 40px;
  padding: 0 10px;
  margin-bottom: 20px;
}
</style>